import { Component, effect, inject, OnInit, untracked } from '@angular/core';
import { AgreementComponent } from '@app2/features/agreement/agreement.component';
import { CookieConsentComponent } from '@app2/shared/components/cookie-consent/cookie-consent.component';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { AppFacade } from '@app2/app.facade';
import { Store } from '@ngrx/store';
import { IconsComponent } from '@app2/core/components/icons/icons.component';
import { initActions } from '@app2/store/init/init.actions';
import { InitStore } from '@app2/store/init/init.store';
import { NgIf } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { DialogService } from 'primeng/dynamicdialog';
import { AuthComponent } from '@app2/features/auth/auth.component';
import { AnalystService } from '@app/services/analyst/analyst.service';
import { AnalyticsEventsEnum } from '@core/models/analytics.model';
import { authActions } from '@app2/store/auth/auth.actions';

@Component({
  selector: 'sens-app',
  imports: [
    RouterOutlet,
    AgreementComponent,
    CookieConsentComponent,
    IconsComponent,
    NgIf,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [AppFacade],
  standalone: true,
})
export class AppComponent implements OnInit {
  private store = inject(Store);

  private facade = inject(AppFacade);

  private initStore = inject(InitStore);

  private dialogService = inject(DialogService);

  private route = inject(ActivatedRoute);

  private router = inject(Router);

  private analystService = inject(AnalystService);

  private queryParams = toSignal(this.route.queryParams);

  public isUserSetAdult$ = this.facade.isUserSetAdult$;

  constructor() {
    effect(() => {
      const queryParams = this.queryParams();

      const clickId = queryParams?.['subid'];
      const code = queryParams?.['code'];

      if (clickId) {
        localStorage.setItem('clickId', clickId);
      }

      if (!!code) {
        this.store.dispatch(authActions.verifyGoogleCode({ code }));
      }
    });

    effect(() => {
      const isAdultSet = this.facade.isUserSetAdult$();
      const pendingAuth = this.facade.pendingAuthDialog$();
      if (isAdultSet && pendingAuth) {
        untracked(() => {
          this.initStore.setPendingAuthDialog(false);
          this.dialogService.open(AuthComponent, {
            header: undefined,
            showHeader: false,
            modal: true,
            dismissableMask: true,
            transitionOptions: '.3s ease-in-out',
          });
        });
      }
    });
  }

  public ngOnInit() {
    this.analystService.logEvent(AnalyticsEventsEnum.AppOpen).then();
    this.store.dispatch(initActions.initApp());
  }
}
